import { SetState } from 'ahooks/lib/useSetState';
import { Table, TableProps } from 'antd';
import { useRef } from 'react';

interface TableParams {
  pageIndex: number;
  pageSize: number;
}
interface params extends TableParams {
  [key: string]: any;
}
type ParamsUpdater = SetState<params> | ((params: Partial<params>) => void);
const CommonTable = <T extends Record<string, any> = any>({
  params,
  setParams,
  dataSource = [],
  total = 0,
  ...restProps
}: TableProps<T> & {
  total?: number;
  params?: params;
  setParams?: ParamsUpdater;
}) => {
  const paginationProps: TableProps<T>['pagination'] = params
    ? {
        showSizeChanger: true,
        current: params.pageIndex,
        pageSize: params.pageSize,
        total: total,
        onChange: (pageIndex, pageSize) => {
          setParams?.({ pageIndex, pageSize });
        },
      }
    : false;
  const columns = restProps.columns || [];
  columns.forEach((column, i) => {
    if (i === columns.length - 1) {
      column.fixed = 'right';
    }
  });
  return (
      <Table
        bordered
        scroll={{ x: 'max-content', scrollToFirstRowOnChange: true }}
        dataSource={dataSource}
        pagination={paginationProps}
        columns={columns}
        sticky
        {...restProps}
      />
  );
};
export default CommonTable;
